export const defaultTheme = {
  colors: {
    white: '#E1E1E6',
    red: '#bd2f33',
    blue: '#3e5da0'
  },
  backgrounds: {
    lightest: '#252131',
    dark: '#191622'
  }
}